import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGradingScaleDetailsByScaleId } from "../../../../services/gradingScaleCalls";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/gradingScaleDetails";

export const gradingScaleDetailsThunk = createAsyncThunk(
  `${sliceName}/gradingScaleDetailsThunk`,
  async (gradingScaleId: string) => {
    const response = await getGradingScaleDetailsByScaleId(gradingScaleId)();
    return response;
  },
  {
    condition: (gradingScaleId, { getState }) => {
      const state = getState() as any;
      return Boolean(gradingScaleId);
    },
  },
);

const gradingScaleDetailsSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {
    clearGradingScaleDetails: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(gradingScaleDetailsThunk.pending, (state) => pendingThunkState(state));
    builder.addCase(gradingScaleDetailsThunk.fulfilled, (state, action) => fulfilledThunkState(action.payload.data));
    builder.addCase(gradingScaleDetailsThunk.rejected, (state) => rejectedThunkState([]));
  },
});
export const { clearGradingScaleDetails } = gradingScaleDetailsSlice.actions;
export default gradingScaleDetailsSlice.reducer;
